import styles from './ProductDescription.module.scss';
import { useState } from 'react';
import { ProductDescriptionTab } from './ProductDescriptionTab';
import { ProductDescriptionContent } from './ProductDescriptionContent';

export interface ProductDescriptionProps {
	productDescriptionItems?: { text?: string; title?: string; id?: string }[];
	productName?: string;
	dictionary: { [key: string]: string };
	countryChosen?: boolean;
}

export const ProductDescription: React.FC<ProductDescriptionProps> = ({
	productDescriptionItems,
	productName,
	dictionary,
	countryChosen = false
}) => {
	const [isActive, setIsActive] = useState<string>(
		productDescriptionItems && productDescriptionItems[0]?.id,
	);

	return (
		<div className={styles.ProductDescription}>
			<div className={styles.ProductDescription_tabContainer}>
				{productDescriptionItems &&
					productDescriptionItems.map((item, index) => (
						<ProductDescriptionTab
							key={index}
							{...item}
							isActive={isActive}
							setIsActive={setIsActive}
							productName={productName}
							dictionary={dictionary}
							countryChosen={countryChosen}
						/>
					))}
				<div
					className={styles.ProductDescription_tabContainerBorder}
				></div>
			</div>
			<div className={styles.ProductDescription_contentContainer}>
				{productDescriptionItems &&
					productDescriptionItems.map((item, index) => (
						<ProductDescriptionContent
							key={index}
							{...item}
							isActive={isActive}
							productName={productName}
							dictionary={dictionary}
							countryChosen={countryChosen}
						/>
					))}
			</div>
		</div>
	);
};
